import { fromJS } from 'immutable';

import { createAsyncAction } from '../utils';
const initialState = fromJS({
    loading: false,
    error: null,
    projects: [],
    groups: []
});

export const getProjectsAndGroups = createAsyncAction('GET_PROJECTS_AND_GROUPS');

export default function dataReducer(state = initialState, action) {
    switch (action.type) {
        case getProjectsAndGroups.REQUEST:
            return fromJS({
                ...state.toJS(),
                loading: true,
                error: null
            });
        case getProjectsAndGroups.SUCCESS:
            return fromJS({
                ...state.toJS(),
                loading: false,
                projects: action.payload.projects,
                groups: action.payload.groups
            });
        case getProjectsAndGroups.FAIL:
            return fromJS({
                ...state.toJS(),
                loading: false,
                error: action.payload
            });
        default:
            return state;
    }
}

export function dataActions($http, colorizer, api, $q) {
    'ngInject'

    function loadData() {
        return dispatch => {
            dispatch({ type: getProjectsAndGroups.REQUEST });
            return $q.all([
                $http.get(`${api.restServiceUrlDB}projects/WithDeployStatusModified`),
                $http.get(`${api.restServiceUrlDB}projects/all`)
            ]).then(
                result => {
                    const responseResult = { projects:result[0].data, groups:result[1].data.groups };
                    dispatch({ type: getProjectsAndGroups.SUCCESS, payload: colorizer.colorize(responseResult) });
                },
                error => {
                    dispatch({ type: getProjectsAndGroups.FAIL, error: true, payload: error.data });
                }
            );
        };
    }

    return { loadData };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/data.reducer.js